webpackJsonp([193],{

/***/ 1454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "为什么不能直接引用 cdn 链接 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2408:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1454),
  /* template */
  __webpack_require__(2951),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/why-cannot-i-use-vux-with-cdn-61.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] why-cannot-i-use-vux-with-cdn-61.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-943046f2", Component.options)
  } else {
    hotAPI.reload("data-v-943046f2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2951:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("为什么不能直接引用 cdn 链接")]), _vm._v(" "), _c('p', [_vm._v("原因见 "), _c('router-link', {
    attrs: {
      "to": "/zh-CN/faq/why-use-vue-file-for-distribution.html"
    }
  }, [_vm._v("为什么使用 .vue 源码分发而不是 js 文件")]), _vm._v("。因为并不会在源码里提供 umd 脚本也不会在发布时发布 umd 脚本，因此没有 cdn 链接。")], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-943046f2", module.exports)
  }
}

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2408);

/***/ })

});


// WEBPACK FOOTER //
// 193.d0f8b49c.js